import React, {useEffect, useState} from 'react';
import {registerCompany, actionCompany, deactivateCompany} from "../../api/web";
import $ from "../../utils/datatables";
import {GET_COMPANIES_URL, SEARCH_COMPANY_URL} from "../../api";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';

const Company = (props) => {

    const [editForm, setEditForm] = useState(false);
    const [stateReady, setStateReady] = useState(false);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        let table = $('#company').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Companies Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax($('.dataTables_filter input').val().length > 0 ? SEARCH_COMPANY_URL($('.dataTables_filter input').val()) : `${GET_COMPANIES_URL}?page=${(data.length + data.start) / data.length}`, {
                    type: 'GET',
                    success : function(res) {
                        let result = [];

                        res.results.map((data) => {
                            result.push({
                                raw: data
                            });
                        });

                        callback({
                            recordsTotal: res.count,
                            recordsFiltered: res.count,
                            data: result
                        });
                    },
                    error: function() {
                        callback({
                            recordsTotal: 0,
                            recordsFiltered: 0,
                            data: []
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.pacra_id;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.tpin;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.email || '—';
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        const status = (data?.verification_status ?? '').toLowerCase();
                        const isVerified = status ? status === 'verified' : data?.is_verified === true;
                        if (status === 'verified' || isVerified) {
                            return `<span class="badge bg-success text-white">Verified</span>`;
                        }
                        if (status === 'rejected') {
                            return `<span class="badge bg-danger text-white">Rejected</span>`;
                        }
                        if (status === 'under_review') {
                            return `<span class="badge bg-warning text-white">Under Review</span>`;
                        }
                        if (status === 'pending_documents') {
                            return `<span class="badge bg-info text-white">Pending</span>`;
                        }
                        return `<span class="badge bg-danger text-white">Unverified</span>`;
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        const status = (data?.verification_status ?? '').toLowerCase();
                        const isVerified = status ? status === 'verified' : data?.is_verified === true;
                        // return `<nav class="nav nav-icon-only"><a href="#" class="nav-link view_company"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link approve_company"><i class="fa fa-check"></i>Approve</a> <a href="#" class="nav-link delete_company"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                        return !isVerified
                            ? `<nav class="nav nav-icon-only"><a href="#" class="nav-link view_company"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link approve_company"><i class="fa fa-check"></i>Approve</a> </nav>`
                            : `<nav class="nav nav-icon-only"><a href="#" class="nav-link view_company"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link deactivate_company"><i class="fa fa-close"></i> Deactivate</a> </nav>`;
                    },
                    "targets": 5,
                    "className": "text-nowrap"
                }
            ]
        });

        table.on('click', '.approve_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            const status = (extract_td?.raw?.verification_status ?? '').toLowerCase();
            const isVerified = status ? status === 'verified' : extract_td?.raw?.is_verified === true;
            if(isVerified) return toast.error("Company already approved.", {position: "top-right"});

            // Navigate to document review page (admin approval/rejection happens there).
            props.history.push(`/company/${extract_td.raw.pacra_id}/verification`);
            return false;
        });

        table.on('click', '.deactivate_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            const options = {
                position: "top-right",
                hideAfter: 3
            };

            const _options = {
                position: "top-right"
            };

            const status = (extract_td?.raw?.verification_status ?? '').toLowerCase();
            const isVerified = status ? status === 'verified' : extract_td?.raw?.is_verified === true;
            if(!isVerified) return toast.error("Company already approved.", _options);

            const toastId2 = toast.loading('Please wait... contacting to server.', {position: "top-right"});

            deactivateCompany("patch", extract_td.raw.pacra_id, {pacra_id: extract_td.raw.pacra_id}).then((result) => {
                toast.dismiss(toastId2);

                if(result.error === false) {
                    $('#company').DataTable().ajax.reload(null, false);
                    toast.success("Company successfully disapproved.", _options);
                } else {
                    toast.error(result.payload, _options);
                }
            });

            return false;
        });

        table.on('click', '.delete_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            const options = {
                position: "top-right",
                hideAfter: 3
            };

            const toastId3 = toast.loading('Please wait... contacting to server.', {position: "top-right"});

            actionCompany("delete", extract_td.raw.pacra_id, {}).then((result) => {
                toast.dismiss(toastId3);
                const _options = {
                    position: "top-right"
                };

                if(result.error === false) {
                    $('#company').DataTable().ajax.reload(null, false);
                    toast.success("Company successfully removed.", _options);
                } else {
                    toast.error("Something went wrong.", _options);
                }
            });

            return false;
        });

        table.on('click', '.view_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            props.history.push(`/company/${extract_td.raw.pacra_id}`);

            return false;
        });

    }, [])

    const handleShowModal = () => {
        setEditForm(false);
        $('#company_form').parsley();
        $("#modalCompany").modal("show");
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const reloadTable = () => {
        $('#company').DataTable().ajax.reload(null, false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setStateReady(true);

        let data = {
            pacra_id: $("#pacra_id").val(),
            name: $("#name").val(),
            tpin: $("#tpin").val(),
            address: $("#address").val(),
            phone_number: $("#phone_number").val(),
            email: $("#email").val()
        }

        if(editForm === true) {
            actionCompany("patch", editId, data).then((response) => {
                setStateReady(false);
                if(response.error) return toast.error("Something went wrong...", {position: "top-right"});
                onCloseModal("modalCompany", "company_form");
                $('#company').DataTable().ajax.reload();
                return toast.success("Company account successfully created.", {position: "top-right"});
            });

            return false;
        }

        registerCompany(data).then((response) => {
            setStateReady(false);
            if(response.error) return toast.error("Something went wrong...", {position: "top-right"});
            onCloseModal("modalCompany", "company_form");
            $('#company').DataTable().ajax.reload();
            return toast.success("Company account successfully created.", {position: "top-right"});
        })
    }

    const onCloseModal = (id, form) => {
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        $(`#${form}`).parsley().reset();
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Company</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Company</h4>
                    </div>
                    {/*<div className="d-none d-md-block">*/}
                    {/*    <button className="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-user-plus"></i> Add New</button>*/}
                    {/*</div>*/}
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Company</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="company" className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th>PacraID</th>
                                        <th>Name</th>
                                        <th>TPIN</th>
                                        <th>Email</th>
                                        <th>Status</th>
                                        <th className="text-nowrap">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalCompany" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalCompany", "company_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Company" : "Create Company"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} company to have access to the app/dashboard</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="company_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                        <div id="pacraWrapper" className="form-group parsley-input">
                                            <label>Pacra ID<span className="tx-danger">*</span></label>
                                            <input id="pacra_id" type="text" className="form-control"
                                                   placeholder="Enter pacra id"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#pacraWrapper" required/>
                                        </div>
                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Company Name<span className="tx-danger">*</span></label>
                                            <input id="name" type="text" className="form-control"
                                                   placeholder="Enter company name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper" required/>
                                        </div>

                                        <div id="tpinWrapper" className="form-group parsley-input">
                                            <label>TPIN Number<span className="tx-danger">*</span></label>
                                            <input id="tpin" type="number" className="form-control"
                                                   placeholder="Enter tpin number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#tpinWrapper" required/>
                                        </div>

                                        <div id="emailWrapper" className="form-group parsley-input">
                                            <label>Email Address<span className="tx-danger">*</span></label>
                                            <input id="email" type="text" className="form-control"
                                                   placeholder="Enter email address"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#emailWrapper" required/>
                                        </div>

                                        <div id="mobileWrapper" className="form-group parsley-input">
                                            <label>Mobile Number<span className="tx-danger">*</span></label>
                                            <input id="phone_number" type="text" className="form-control"
                                                   placeholder="Enter Mobile Number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#mobileWrapper" required/>
                                        </div>

                                        <div id="addressWrapper" className="form-group parsley-input">
                                            <label>Address<span className="tx-danger">*</span></label>
                                            <input id="address" type="text" className="form-control"
                                                   placeholder="Enter address"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#addressWrapper" required/>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-success btn-block">Update Company</button> : <button className="btn btn-success btn-block">Create Company</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Company;
